import React, { useEffect, useState } from "react";
import View from "./ui/view";
import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";
import {
  typeAlert,
  icons,
  sizesIcon,
  ContextMenuAFY,
  IconAFY,
} from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { SponsorModel } from "../../model/sponsor";
import { CobranzaHeader } from "./ui/header";
import { themeCore } from "../../assets/themes/theme";
import LocalStorageService from "../../services/localStorage";
import { getCollections } from "../../resources/helper/collection";




import { useStyles } from "./assets/style";
import "./assets/style.css";
import { use } from "i18next";

const storageKey2 = "afy-login";
const lsLogin = new LocalStorageService(storageKey2);

const Billing = () => {
  const dispatch = useDispatch();
  const [clientId] = React.useState<string>(
    lsLogin.getUserLoginStored().clientId,
  );
  const [collections, setCollections] = React.useState<any[]>([]);
  const classes = useStyles();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState<boolean>(false);
  const [seeToast, setSeeToast] = React.useState<{
    show: boolean;
    type: typeAlert;
    message: string;
  }>({
    show: false,
    message: "",
    type: typeAlert.success,
  });
  const [count, setCount] = useState<number>(100);
  const [rowsPerPages, setRowsPerPages] = useState<number>(10);
  const [pagePagination, setPagePagination] = useState<number>(1);


  const handleOnClickNext = (data: any) => {
    console.log(data);
  }
  const onClickBack = () => {
    navigate("/admin");
  };
  const onClickGenerate = () => {
    navigate("/admin/generate-billing");
  };

  const getStatusLabel = (estado: string) => {
    switch (estado) {
      case "BANK_PAYMENT_PENDING":
        return "En Proceso";
      case "COMPLETED":
        return "Completado";
      case "FAILED":
        return "Fallido";
      case "PROCESSING_BANK_FILE":
        return "Procesando Pagos";
      case "GENERATING_BANK_FILE":
        return "Generando archivo";
      default:
        return estado;
    }
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const fetchCollections = async () => {
    setLoading(true);
    setCollections([]);
    try {
      const response = await getCollections(true, pagePagination, rowsPerPages);


      if (response) {
   
      //  response.data.sort((a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());

        //item.batchFiles = item.batchFiles.map((file: any) => file.url)
        response.data.map((item: any) => {
          let newItem = {
            id: item.id,
            tipo: "Recepción de pagos",
            estado: getStatusLabel(item.status),
            usuario: item.parameters.userName,
            fecha: formatDate(item.createdAt),
            archivos: item.batchFiles.length,
            children: item.batchFiles.length > 0 && [
              {
                id: "5.1",
                tipo: "Detalles",
                estado: "",
                usuario: "",
                fecha: "",
                archivos: 0,
                referencia: "",
                detalles: item.batchFiles.map((file: any) => file.url),
                actionText: "Descargar Archivos",
              },
            ],
          };
          setCollections((prev) => [...prev, newItem]);
        });

      }
    } catch (error) {
      console.error("Error fetching collections:", error);
    } finally {
      setLoading(false);
    }
  };

  const downloadFiles = async (e: any) => {
    const fileUrl = e.detalles;
    console.log("Descargando archivos:", fileUrl);

    // Validate input
    if (!fileUrl || !Array.isArray(fileUrl) || fileUrl.length === 0) {
      setSeeToast({
        show: true,
        message: "No hay archivos disponibles para descargar",
        type: typeAlert.warning,
      });
      return;
    }

    try {
      let successCount = 0;
      
      // Download files sequentially with delay to avoid browser blocking
      for (let i = 0; i < fileUrl.length; i++) {
        const url = fileUrl[i];
        
        if (!url || typeof url !== 'string') {
          console.warn("URL inválida encontrada:", url);
          continue;
        }

        try {
          // Create download link
          const link = document.createElement("a");
          link.href = url;
          link.download = url.split("/").pop() || `file_${i + 1}`;
          link.target = "_blank"; // Open in new tab to avoid CORS issues
          link.rel = "noopener noreferrer";
          
          // Add to DOM, click, and remove
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          
          successCount++;
          
          // Add delay between downloads to prevent browser blocking
          if (i < fileUrl.length - 1) {
            await new Promise(resolve => setTimeout(resolve, 500)); // 500ms delay
          }
          
        } catch (error) {
          console.error(`Error downloading file from ${url}:`, error);
        }
      }

      if (successCount === 0) {
        setSeeToast({
          show: true,
          message: "No se pudo iniciar la descarga de ningún archivo",
          type: typeAlert.error,
        });
      } else {
        setSeeToast({
          show: true,
          message: `Iniciada la descarga de ${successCount} archivo(s)`,
          type: typeAlert.success,
        });
      }

    } catch (error) {
      console.error("Error general en descarga:", error);
      setSeeToast({
        show: true,
        message: "Error general al descargar los archivos",
        type: typeAlert.error,
      });
    }
  };
  const onChangePage = (page: number) => {
    setPagePagination(page);
  };
  const onChangeRowsPerPage = (rows: number) => {
   
    setRowsPerPages(rows);
    setPagePagination(1);
    //setRowsPerPages(rows);
  }

  useEffect(() => {
    fetchCollections();
  }
    , [pagePagination]);

  return (
    <React.Fragment>

      <CobranzaHeader
        loading={loading}
        seeToast={seeToast}
        setSeeToast={setSeeToast}
      />

      <View
        onClickNext={handleOnClickNext}
        title={"Cobranza"}
        data={collections}
        count={count}
        pagePagination={pagePagination}
        rowsPerPages={rowsPerPages}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}

        columns={[
          {
            accessorKey: "actions",
            header: "",
            size: 50,
            enableResizing: false,
            cell: ({ row }: any) => {

              return (
                <ContextMenuAFY
                  colorButton="#fff"
                  iconButton={icons.MoreVert}
                  iconColor="#3A56A1"
                  menuItem={[
                    {
                      disabled: false,
                      id: "1",
                      name: "Ver Detalles",
                    },
                    {
                      disabled: false,
                      id: "2",
                      name: "Aplicar Pagos",
                    },

                  ]}
                  onClickContextMenu={(item) => {
                    console.log(item, row.original);
                    if (item.id === "1") {
                      navigate("/admin/generate-billing", {
                        state: {
                          id: row.original.id,
                          tipo: row.original.tipo,
                          estado: row.original.estado,
                          usuario: row.original.usuario,
                          fecha: row.original.fecha,
                          archivos: row.original.archivos,
                          referencia: row.original.referencia,
                          readOnly: true,
                        },
                      });
                    }
                    if (item.id === "2") {
                      //console.log("Aplicar Pagos", row.original.children[0].detalles);
                      navigate("/admin/collect", {
                        state: {
                          id: row.original.id,
                          tipo: row.original.tipo,
                          estado: row.original.estado,
                          usuario: row.original.usuario,
                          fecha: row.original.fecha,
                          archivos: row.original.archivos,
                          referencia: row.original.referencia,
                        },
                      });
                    }
                  }}
                  sizeIcon={sizesIcon.standard}
                />
              );
            }
          },
          {
            accessorKey: "id",
            header: "",
            cell: ({ row }: any) => {
              const hasChildren = row.original.children?.length > 0;
              return (
                <div style={{ paddingLeft: `${row.depth * 20}px` }} className="cell">
                  {hasChildren && (
                    <button
                      className="expand-btn"
                      onClick={() => row.toggleExpanded()}
                    >
                      {row.getIsExpanded() ? <IconAFY icon={icons.KeyboardArrowUp} /> : <IconAFY icon={icons.KeyboardArrowDown} />}
                    </button>
                  )}

                </div>
              );
            },
          },
          {
            accessorKey: "tipo",
            header: "Tipo",

          },
          {
            accessorKey: "estado",
            header: "Estado",
          },
          {
            accessorKey: "usuario",
            header: "Usuario",
          },
          {
            accessorKey: "fecha",
            header: "Fecha de Creación",
          },
          {
            accessorKey: "archivos",
            header: "Archivos",
          },

        ]}
        onClickGenerate={onClickGenerate}
        onClickDownload={(e: any) => { downloadFiles(e) }}
        backgroundColorBack={themeCore.colors.primary}
        backgroundColorNext={themeCore.colors.primary}
        onClickRefresh={() => {
          fetchCollections();
        }}
        onClickBack={onClickBack}
        next={{
          nextLabel: "",
          previousLabel: "",
          nextDisabled: false,
        }


        }
      />

    </React.Fragment>
  );
};

export default Billing;
